import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  SECRET = 'Pa$$w0rd008k!';
  constructor(private http: HttpClient) { }

  lightThemeUrl='https://frenchaydevapi.smileorchard.co.uk/Configuration';
 
  subDomainLink = '';

  errorMsg = '<p class="text-danger">Oops! Something went wrong, Please refresh the page and try again. If problem persists, please contact our technical team on <a href="tel:+44 01303 488695">+44 01303 488695</a> / <a href="mailto:techsupport@dentalroutes.org">techsupport@dentalroutes.org</a></p>'

  enc(plainText) {
    const b64 = CryptoJS.AES.encrypt(plainText, this.SECRET).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const eHex = e64.toString(CryptoJS.enc.Hex);
    return eHex;
  }
  dec(cipherText) {
    const reb64 = CryptoJS.enc.Hex.parse(cipherText);
    const bytes = reb64.toString(CryptoJS.enc.Base64);
    const decrypt = CryptoJS.AES.decrypt(bytes, this.SECRET);
    const plain = decrypt.toString(CryptoJS.enc.Utf8);
    return plain;
  }
  getLightTheme(LightTheme){
    let params = new HttpParams();
    params = params.append('Type',LightTheme);
    return this.http.get<any>(`${environment.configUrl}Configuration/GetColourCodeByType`,{params: params})
  }
  getDarkTheme(LightTheme){
    let params = new HttpParams();
    params = params.append('Type',LightTheme);
    return this.http.get<any>(`${environment.configUrl}Configuration/GetColourCodeByType`,{params: params})
  }
  getDefaultTheme(LightTheme){
    let params = new HttpParams();
    params = params.append('Type',LightTheme);
    return this.http.get<any>(`${environment.configUrl}Configuration/GetColourCodeByType`,{params: params})
  }
}
